import { render, staticRenderFns } from "./RightNav.vue?vue&type=template&id=098d3684&"
import script from "./RightNav.vue?vue&type=script&lang=js&"
export * from "./RightNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports